import { render, staticRenderFns } from "./PlanCompare.vue?vue&type=template&id=2a35bf4c"
import script from "./PlanCompare.vue?vue&type=script&lang=js"
export * from "./PlanCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports